var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1223 18.4596C22.6918 18.4596 23.2379 18.2334 23.6405 17.8308C24.0431 17.4281 24.2693 16.882 24.2693 16.3126V4.50417C24.2693 3.93475 24.0431 3.38865 23.6405 2.98602C23.2379 2.58338 22.6918 2.35718 22.1223 2.35718H10.8077C11.1834 3.01201 11.3874 3.75272 11.3874 4.50417H22.1223V16.3126H12.4609V18.4596M16.7549 7.72465V9.87164H10.3139V23.8271H8.16692V17.3861H6.01993V23.8271H3.87294V15.2391H2.2627V9.87164C2.2627 9.30222 2.4889 8.75613 2.89153 8.35349C3.29417 7.95085 3.84027 7.72465 4.40968 7.72465H16.7549ZM9.24041 4.50417C9.24041 5.07358 9.01421 5.61968 8.61157 6.02232C8.20893 6.42496 7.66284 6.65116 7.09342 6.65116C6.524 6.65116 5.97791 6.42496 5.57527 6.02232C5.17263 5.61968 4.94643 5.07358 4.94643 4.50417C4.94643 3.93475 5.17263 3.38865 5.57527 2.98602C5.97791 2.58338 6.524 2.35718 7.09342 2.35718C7.66284 2.35718 8.20893 2.58338 8.61157 2.98602C9.01421 3.38865 9.24041 3.93475 9.24041 4.50417Z",
    fill: "#FEC200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.16a8e53abc190334c0d06f6ffe7c1763.svg";
export { ForwardRef as ReactComponent };